export default __webpack_public_path__ + "6f09fe104694fbd92be58fabc20e7df0.png";